module.exports = __webpack_public_path__ + "img/auto-compras-blanco.c5d7e7ac.webp";